'use client';
import Section9_FindHospital from './Section9_FindHospital';

export default function FindHospitalContent() {
  return (
    <div className="standalone-page">
      <Section9_FindHospital />
      <style jsx>{`
        .standalone-page {
          background: #fff;
          min-height: 100vh;
        }
      `}</style>
    </div>
  );
}
